import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { BankAccountService } from '@common/services/bank-account.service';
import { DashboardService } from '@pages/dashboard/dashboard.service';
import { filter, firstValueFrom } from 'rxjs';

export const bankAccountGuard: CanActivateFn = async () => {
  const _BankAccountService = inject(BankAccountService);
  const _DashboardService: DashboardService = inject(DashboardService);

  await firstValueFrom(_DashboardService.fetchInvestorProfileData());

  await firstValueFrom(
    _DashboardService.investorProfile.pipe(
      filter(profile => profile !== undefined)
    )
  );

  return firstValueFrom(_BankAccountService.checkBankAccountNavigation());
};
